// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientPeopleListViewTable_ClientProfileRelationshipFragment = { __typename?: 'ClientProfileRelationship', id: string, type: Types.ClientProfileRelationshipType, toClientProfile: { __typename?: 'ClientProfile', id: string, isPrimary: boolean } };

export type ClientPeopleListViewTable_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, legalName: string, displayName: string, displayGivenName: string, isGrantor: boolean, isPrimary: boolean, address?: { __typename?: 'Address', id: string, stateCode: string } | null, relationships?: Array<(
    { __typename?: 'ClientProfileRelationship' }
    & ClientPeopleListViewTable_ClientProfileRelationshipFragment
  )> | null, professionalTeamRoles: { __typename?: 'ProfessionalTeamRoleConnection', edges?: Array<{ __typename?: 'ProfessionalTeamRoleEdge', node?: { __typename?: 'ProfessionalTeamRole', id: string, kind: Types.ProfessionalTeamRoleKind, otherRoleName?: string | null, powerOfAttorneyKind?: Types.ProfessionalTeamRolePowerOfAttorneyKind | null } | null } | null> | null }, onboardedIndividualSuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null };

export type ClientPeopleListViewTable_ClientOrganizationFragment = { __typename?: 'ClientOrganization', id: string, kind?: Types.ClientOrganizationKind | null, name: string, onboardedOrganizationSuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null };

export type ClientPeopleListViewTableQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type ClientPeopleListViewTableQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', newIndividualsAutomaticallyOnboardedAt?: Time | null, id: string, integrationClients?: Array<{ __typename?: 'IntegrationClient', id: string, kind: Types.IntegrationClientKind }> | null, clientProfiles?: Array<(
          { __typename?: 'ClientProfile', id: string }
          & ClientPeopleListViewTable_ClientProfileFragment
        )> | null, clientOrganizations?: Array<(
          { __typename?: 'ClientOrganization', id: string }
          & ClientPeopleListViewTable_ClientOrganizationFragment
        )> | null } | null } | null> | null }, primaryClients: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: (
        { __typename?: 'ClientProfile', id: string }
        & ClientPeopleListViewTable_ClientProfileFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    ClientPeopleListViewTable: 'ClientPeopleListViewTable' as const
  },
  Fragment: {
    ClientPeopleListViewTable_ClientProfileRelationship: 'ClientPeopleListViewTable_ClientProfileRelationship' as const,
    ClientPeopleListViewTable_ClientProfile: 'ClientPeopleListViewTable_ClientProfile' as const,
    ClientPeopleListViewTable_ClientOrganization: 'ClientPeopleListViewTable_ClientOrganization' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientPeopleListViewTable_ClientProfileRelationshipFragmentDoc = gql`
    fragment ClientPeopleListViewTable_ClientProfileRelationship on ClientProfileRelationship {
  id
  type
  toClientProfile {
    id
    isPrimary
  }
}
    `;
export const ClientPeopleListViewTable_ClientProfileFragmentDoc = gql`
    fragment ClientPeopleListViewTable_ClientProfile on ClientProfile {
  id
  legalName
  displayName
  displayGivenName
  isGrantor
  isPrimary
  address {
    id
    stateCode
  }
  relationships {
    ...ClientPeopleListViewTable_ClientProfileRelationship
  }
  professionalTeamRoles {
    edges {
      node {
        id
        kind
        otherRoleName
        powerOfAttorneyKind
      }
    }
  }
  onboardedIndividualSuggestion {
    id
  }
}
    ${ClientPeopleListViewTable_ClientProfileRelationshipFragmentDoc}`;
export const ClientPeopleListViewTable_ClientOrganizationFragmentDoc = gql`
    fragment ClientPeopleListViewTable_ClientOrganization on ClientOrganization {
  id
  kind
  name
  onboardedOrganizationSuggestion {
    id
  }
}
    `;
export const ClientPeopleListViewTableDocument = gql`
    query ClientPeopleListViewTable($householdId: ID!) {
  households(where: {id: $householdId}) {
    edges {
      node {
        newIndividualsAutomaticallyOnboardedAt
        integrationClients {
          id
          kind
        }
        clientProfiles {
          id
          ...ClientPeopleListViewTable_ClientProfile
        }
        clientOrganizations {
          id
          ...ClientPeopleListViewTable_ClientOrganization
        }
        id
      }
    }
  }
  primaryClients: clientProfiles(
    where: {and: [{hasHouseholdWith: {id: $householdId}}, {isPrimary: true}]}
    orderBy: {direction: ASC, field: created_at}
  ) {
    edges {
      node {
        id
        ...ClientPeopleListViewTable_ClientProfile
      }
    }
  }
}
    ${ClientPeopleListViewTable_ClientProfileFragmentDoc}
${ClientPeopleListViewTable_ClientOrganizationFragmentDoc}`;

/**
 * __useClientPeopleListViewTableQuery__
 *
 * To run a query within a React component, call `useClientPeopleListViewTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientPeopleListViewTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientPeopleListViewTableQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useClientPeopleListViewTableQuery(baseOptions: Apollo.QueryHookOptions<ClientPeopleListViewTableQuery, ClientPeopleListViewTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientPeopleListViewTableQuery, ClientPeopleListViewTableQueryVariables>(ClientPeopleListViewTableDocument, withFetchPolicyContext(options));
      }
export function useClientPeopleListViewTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientPeopleListViewTableQuery, ClientPeopleListViewTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientPeopleListViewTableQuery, ClientPeopleListViewTableQueryVariables>(ClientPeopleListViewTableDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useClientPeopleListViewTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientPeopleListViewTableQuery, ClientPeopleListViewTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientPeopleListViewTableQuery, ClientPeopleListViewTableQueryVariables>(ClientPeopleListViewTableDocument, withFetchPolicyContext(options));
        }
export type ClientPeopleListViewTableQueryHookResult = ReturnType<typeof useClientPeopleListViewTableQuery>;
export type ClientPeopleListViewTableLazyQueryHookResult = ReturnType<typeof useClientPeopleListViewTableLazyQuery>;
export type ClientPeopleListViewTableSuspenseQueryHookResult = ReturnType<typeof useClientPeopleListViewTableSuspenseQuery>;
export type ClientPeopleListViewTableQueryResult = Apollo.QueryResult<ClientPeopleListViewTableQuery, ClientPeopleListViewTableQueryVariables>;